import { IBundleProductConfiguration, IConfiguration } from "./types";

export default class BundleProductConfiguration implements IBundleProductConfiguration {

  id: number;
  value: string | number;
  configuration: IConfiguration;

  constructor(
    id: number,
    value: string | number,
    configuration: IConfiguration
  ) {
    this.id = id;
    this.value = value;
    this.configuration = configuration;
  }

}
